import React                                                        from 'react';
import { withStyles }                                               from '@material-ui/core/styles';
import {colores, globales,funciones}                                from '../../global';
import BarraBotones                                                 from '../../components/Barra_menu';
import AuthService                                                  from '../../AuthService';
import Request                                                      from 'superagent';
import Select                                                       from '../../components/Select';
import TextField                                                    from '@material-ui/core/TextField';
import Paper                                                        from '@material-ui/core/Paper';
import Reporte                                                      from '../../components/Modalreporte';
import Drawer                                                       from '@material-ui/core/Drawer';
import CircularProgress                                             from '@material-ui/core/CircularProgress';
import Backdrop                                                     from '@material-ui/core/Backdrop';
import Icono                                                        from '../../components/Icono'
import FilterListRoundedIcon                                        from '@material-ui/icons/FilterListRounded';
import {Typography}                                                 from '@material-ui/core';
import Switch                                                       from '@material-ui/core/Switch';
import FormControlLabel                                             from '@material-ui/core/FormControlLabel';
import SpeedDial                                                    from '@material-ui/lab/SpeedDial';
import SpeedDialIcon                                                from '@material-ui/lab/SpeedDialIcon';
import SpeedDialAction                                              from '@material-ui/lab/SpeedDialAction';
import SettingsTwoToneIcon                                          from '@material-ui/icons/SettingsTwoTone';
import SettingsIcon                                                 from '@material-ui/icons/Settings';
import Autocomplete                                                 from '@material-ui/lab/Autocomplete';
import {virtual}                                                    from '../../components/VirtualListBox';
import MenuItem                                                     from '@material-ui/core/MenuItem';
import { KeyboardDatePicker, MuiPickersUtilsProvider }              from "@material-ui/pickers";
import DateFnsUtils                                                 from "@date-io/date-fns";
import esLocale                                                     from "date-fns/locale/es";
import                                                                    'date-fns';
import CustomToolbar                                                from '../../components/toolbarPicker'; 
import LinearProgress from '@material-ui/core/LinearProgress';

let Auth = new AuthService();
var ip=globales.ip
var border_dialog=globales.border_dialog
var url_reporte;
var parametros_reporte;
var movil=/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
var movil_pequeño=/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
const ListboxComponent = virtual.ListboxComponent;


/*                           CLASES DE ESTILO                       */
var styles = theme =>({
    Dialog:{
        borderRadius: border_dialog,
        margin:0,
        padding:0
    },
    root_speed:{
      padding:0,
    },
    actionsClosed:{
      transition: 'top 0s linear 5.2s',
    },
    fab_speed:{
      background: 'rgba(0, 33, 88 ,0.9)',
      padding:0,
      margin:0,
      borderRadius:2,
      borderTopRightRadius:3,
      borderBottomLeftRadius:45
      
    },
    backdrop: {
      zIndex: 5000,
      color: '#fff', 
      flexDirection: 'column',
      background:'rgba(0,0,0,0.8)'
    },
    select: { //CONFIGURA EL SELECT 
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'50%',
      },
      textField: {
        margin: theme.spacing(movil_pequeño?2:1, 1,0,0),
        padding: 0,
        minWidth: movil_pequeño?'100%':'20%',
        width: '20%'      
      },
      root: {
        width: 40,
        height: 24,
        padding: 0,
        margin: theme.spacing(1),
      },
      Switch:{
        padding: 1,
        '&$checked': {
          transform: 'translateX(16px)',
          color: theme.palette.common.white,
          '& + $track': {
            backgroundColor: '#52d869',
            opacity: 1,
            border: 'none',
          },
        },
      },
      thumb: {
        width: 22,
        height: 22,
      },
      track: {
        borderRadius: 26 / 2,
        border: `1px solid grey`,
        backgroundColor: 'grey',
        opacity: 1,
        transition: theme.transitions.create(['background-color', 'border']),
      },
      checked: {},
    })


/*                                        EXPORT                                      */
export default withStyles(styles)(
    class ReporteParametros extends React.Component  {

      constructor(props) {
        super(props);
        this.l= props.l
        this.e= props.e
        this.i= props.i
        this.label_reporte =      props.label_reporte
        this.actualizarbarra=     props.actualizarbarra
        this.actualizarcircular=  props.actualizarcircular



        this.state = {
            openBackDrop:       false, 
            isLoggin:           undefined,
            parametros:         [],
            parametros_extras:  [],
            label_reporte:      '',
            parametros_final:   '',
            open_parametros:    true,
            switch:             false,
            url:                '',
            cargando:           false,
            open_speed:         false,
            url_reporte:        '',
            debe_validar:       false,
            parametros_validar: '',
            validando:          false,
            error:              false,
            parametro_error:    '',
        }
        
}; //FIN CONSTRUCTORS


componentDidMount()
{
        let thiss = this;
        Auth.loggedIn().then( function(b){
          thiss.setState({ isLoggin: b,label_reporte: thiss.label_reporte})
            if(b)
            thiss.setState({cargando:true},()=>{
            Request.post(`${ip}/obtener_parametros_reporte`)
            .set({'authorization': 'Bearer ' + Auth.getToken() })
            .set('Content-Type', 'application/json')
            .send({LABEL_REPORTE:  thiss.label_reporte,cuenta_alumno:  Auth.getProfile().user.toString()})
            .retry(0)
            .timeout({ response: 15000, deadline: 60000, }) 
            .end((err, res) => {

             if (err) { 
                    if (err.toString().substr(0,16) === 'Error: Forbidden')
                    {
                      window.location.reload();
                      return;  
                    }
                    (async function() {
                        funciones.showToast('e','Error de conexión')
                    })();//FIN FUNCION ASYNC
                    thiss.setState({cargando:false});
                    return;
            }

            const tmp = JSON.parse(res.text);
            if(tmp.length>0){
              var tmp_sinesalumno=[]
                tmp.forEach(function getCheck(text, index) {
                  if(!text.ES_ALUMNO)
                  {
                    tmp_sinesalumno.push(text)
                  }

                  if(text.ES_QUERY)
                  {
                    Request.post(`${ip}/obtener_consulta_parametro`)
                    .set({'authorization': 'Bearer ' + Auth.getToken() })
                    .set('Content-Type', 'application/json')
                    .send({QUERY:  text.QUERY_SQL,cuenta_alumno:  Auth.getProfile().user.toString()})
                    .retry(0)
                    .timeout({ response: 15000, deadline: 50000, }) 
                    .end((err, res) => {
                    if (err) { 
                        if (err.toString().substr(0,16) === 'Error: Forbidden')
                        {
                          return;  
                        }
                        (async function() {
                            funciones.showToast('e','Error de conexión');
                        })();//FIN FUNCION ASYNC
                        thiss.setState({error:true, parametro_error: text.NOMBRE});
                        return;
                    }

                    const tmp2 = JSON.parse(res.text);
                    if(tmp2.length>0){
                      if(text.TIPO==='autocomplete')
                      thiss.setState({['datos_'+text.NOMBRE]:tmp2,['json_'+text.NOMBRE]:tmp2})
                      else{
                        const Datos = tmp2.map((datos, i) =>
                          <MenuItem dense  value={datos.ID} key={datos.NOMBRE+text.NOMBRE} name={datos.NOMBRE}  >
                            {datos.NOMBRE}
                          </MenuItem>
                        );
                        thiss.setState({['datos_'+text.NOMBRE]: Datos,['json_'+text.NOMBRE]:tmp2})
                      }
                    }
                    })
                  }

                  thiss.setState({[text.NOMBRE]:text.TIPO==='select' || text.TIPO==='textfield'?'':null})
                  
                  if(index===tmp.length-1){
                    thiss.setState({debe_validar:text.DEBE_VALIDAR, parametros_validar: text.PARAMETROS_VALIDAR,cargando:false,parametros: tmp,parametros_extras: tmp_sinesalumno,open_parametros: Auth.getProfile().plataforma===2?tmp_sinesalumno.length>0?true:false:true}); 

                    if(Auth.getProfile().plataforma===2 && tmp_sinesalumno.length===0){
                      thiss.URL_reporte(thiss.label_reporte,Auth.getProfile().user,'PRINT');
                    }
                  }
                })
            }
            else{
              thiss.setState({label_reporte: thiss.label_reporte,cargando:false});
              thiss.URL_reporte(thiss.label_reporte,'','PRINT');
            }
        })
    })
    })
}

abrirgenerar=()=> event =>{

  var validado  =  true;
  var valores   =  '';
  var thiss     =  this;

  if(Auth.getProfile().plataforma!==2)
  this.state.parametros.forEach(
    function getCheck(text, index){
      if((thiss.state[text.NOMBRE]==='' || thiss.state[text.NOMBRE]===null) && text.PERMITE_NULO===false) validado=false;
    });
  else
  this.state.parametros_extras.forEach(
    function getCheck(text, index){
      if((thiss.state[text.NOMBRE]==='' || thiss.state[text.NOMBRE]===null) && text.PERMITE_NULO===false) validado=false;
    });


    if(validado){
      if(thiss.state.debe_validar)
      {
        var arr_split=[]
        var valores_parametros_validar=''

        arr_split=thiss.state.parametros_validar.split(',')
        arr_split.forEach(
          function getCheck(text, index){
            thiss.state.parametros.forEach(
            function getCheck(text2, index2){
              if(text===text2.NOMBRE){
                valores_parametros_validar=valores_parametros_validar+text2.NOMBRE+':'+(text2.TIPO==='autocomplete'?thiss.state[text2.NOMBRE].ID:thiss.state[text2.NOMBRE])+','
              }
            })
        })

        
        valores_parametros_validar=valores_parametros_validar.substring(0,valores_parametros_validar.length-1)

          this.setState({validando:true},()=>{
          Request.post(`${ip}/se_debe_validar`)
          .set({'authorization': 'Bearer ' + Auth.getToken() })
          .set('Content-Type', 'application/json')
          .send({LABEL_REPORTE:  thiss.label_reporte,PARAMETROS: valores_parametros_validar, cuenta_alumno:  Auth.getProfile().user.toString()})
          .retry(0)
          .timeout({ response: 30000, deadline: 60000, }) 
          .end((err, res) => {
          if (err) { 
              if (err.toString().substr(0,16) === 'Error: Forbidden')
              {
                return;  
              }
              (async function() {
                  //funciones.showToast('e','Error de conexión')
                  funciones.showToast('e',err)
              })();//FIN FUNCION ASYNC
              thiss.setState({validando:false})
              return;
          }

          const tmp2 = JSON.parse(res.text);
          if(tmp2.length>0){
              if(tmp2[0].RESP!=='OK')
              {
                funciones.showToast('w',tmp2[0].RESP);
                thiss.setState({validando:false});
                return;
              }
              else
              {
                this.state.parametros.forEach(
                  function getCheck(text, index){
                    if(index===0)
                      valores= text.ES_ALUMNO&&Auth.getProfile().plataforma===2?Auth.getProfile().user:text.TIPO==='autocomplete'?thiss.state[text.NOMBRE].ID.toString():text.TIPO==='muipickers'?funciones.getDateSelect(thiss.state[text.NOMBRE]):text.PERMITE_NULO?thiss.state[text.NOMBRE].toString()===''?"' '":thiss.state[text.NOMBRE].toString():thiss.state[text.NOMBRE].toString();
                    else
                      valores= valores+','+(text.ES_ALUMNO&&Auth.getProfile().plataforma===2?Auth.getProfile().user:text.TIPO==='autocomplete'?thiss.state[text.NOMBRE].ID.toString():text.TIPO==='muipickers'?funciones.getDateSelect(thiss.state[text.NOMBRE]):text.PERMITE_NULO?thiss.state[text.NOMBRE].toString()===''?"' '":thiss.state[text.NOMBRE].toString():thiss.state[text.NOMBRE].toString());
                  });
          
                  this.setState({parametros_final:valores, validando:false});
          
                  if(this.state.switch)
                    document.getElementById("BT"+this.state.label_reporte).click();
                  else{
                      this.URL_reporte(this.state.label_reporte,valores,'PRINT');
                  }
              }
          }
          else{
            thiss.setState({validando:false})
          }
          
        })
        })
      }
      else{
        this.state.parametros.forEach(
          function getCheck(text, index){
            if(index===0)
              valores= text.ES_ALUMNO&&Auth.getProfile().plataforma===2?Auth.getProfile().user:text.TIPO==='autocomplete'?thiss.state[text.NOMBRE].ID.toString():text.TIPO==='muipickers'?funciones.getDateSelect(thiss.state[text.NOMBRE]):text.PERMITE_NULO?thiss.state[text.NOMBRE].toString()===''?"' '":thiss.state[text.NOMBRE].toString():thiss.state[text.NOMBRE].toString();
            else
              valores= valores+','+(text.ES_ALUMNO&&Auth.getProfile().plataforma===2?Auth.getProfile().user:text.TIPO==='autocomplete'?thiss.state[text.NOMBRE].ID.toString():text.TIPO==='muipickers'?funciones.getDateSelect(thiss.state[text.NOMBRE]):text.PERMITE_NULO?thiss.state[text.NOMBRE].toString()===''?"' '":thiss.state[text.NOMBRE].toString():thiss.state[text.NOMBRE].toString());
          });
  
          this.setState({parametros_final:valores});
  
          if(this.state.switch)
            document.getElementById("BT"+this.state.label_reporte).click();
          else{
              this.URL_reporte(this.state.label_reporte,valores,'PRINT');
          }
      }
    }
    else{
      funciones.showToast('w','Valide los datos ingresados.');
    }
};

URL_reporte=(reporte,parametros_valores,tipo)=> {
 
  this.setState({cargando:true},()=>{
  try{
    Request.get(`${globales.ip}/generar_token_knowage/${reporte}/${Auth.getProfile().rol}/${Auth.getProfile().plataforma===2?'PDF':tipo}`)
    .set({'authorization': 'Bearer ' + Auth.getToken() })
    .retry(1)
    .timeout({ response: 20000, deadline: 60000, }) 
    .end((err, res)=>{ 
      if (err) { 
        if (err.toString().substr(0,16) === 'Error: Forbidden')
        {
          return;  
        }
        (async function() {
            funciones.showToast('e','Error de conexión')
        })();//FIN FUNCION ASYNC
        this.setState({cargando: false});
        return;
        
    }

        const tmp = JSON.parse(res.text);
        if (tmp.URL!=='') //SI HAY REGISTROS
        {
          url_reporte= tmp.URL;
          parametros_reporte= tmp.PARAMETROS;
          if(parametros_reporte!=='')
          {
            var param = parametros_reporte.split(',');
            var param_valor = parametros_valores.split(',');
            for(var x=0; x<param.length; x++)
            {
              url_reporte=url_reporte+'&'+param[x]+'='+param_valor[x];
            }
          }
        
        if(!movil)
          this.setState({url: url_reporte, cargando: true,open_parametros:false});     
        else
        {
          var windowSize = "width=" + window.innerWidth + ",height=" + window.innerHeight + ",scrollbars=no";
          this.setState({cargando: false},()=>{window.open(url_reporte, 'Reporte', windowSize);  })
        }   
    }  
    else{
      funciones.showToast('w','No se encontro el reporte.')
      this.setState({cargando: false});
    }                
  })
  }
  catch(ex){
    funciones.showToast('e','Error en el proceso.')
    this.setState({cargando: false})
  }
})
}

botoncancelar=()=>event=>{
  if(!movil_pequeño)
  this.setState({open_parametros:false})
}

botonlimpiar=()=>event=>{
  var thiss=this
  if(Auth.getProfile().plataforma!==2)
  this.state.parametros.forEach(
    function getCheck(text, index) {
      if(text.TIPO==='select' || text.TIPO==='textfield')
      thiss.setState({[text.NOMBRE]:''})
      else
      thiss.setState({[text.NOMBRE]:null})
  })
  else{
    this.state.parametros_extras.forEach(
      function getCheck(text, index) {
        if(text.TIPO==='select' || text.TIPO==='textfield')
        thiss.setState({[text.NOMBRE]:''})
        else
        thiss.setState({[text.NOMBRE]:null})
    })
  }
}

onChange=(VARIABLE)=>event=>{
  var thiss=this
  
  this.state.parametros.forEach(
    function getCheck(text, index) {
      var found
      if(text.NOMBRE===VARIABLE)
      {
        found=thiss.state.parametros.filter(grupo => grupo.SECUENCIA_PARAMETRO ===  text.SECUENCIA && grupo.ESPERA_PARAMETRO);

        if(found!==null)
        {
          found.forEach(function getCheck(text, index) {
            if(text.TIPO==='select'){
              const Datos = thiss.state['json_'+text.NOMBRE].filter((row)=>thiss.Condicion(text.CONDICION,row[text.COLUMNA],event.target.value)).map((datos, i) =>
                <MenuItem dense  value={datos.ID} key={datos.NOMBRE+text.NOMBRE} name={datos.NOMBRE}  >
                  {datos.NOMBRE}
                </MenuItem>
              );
              thiss.setState({['datos_'+text.NOMBRE]: Datos})
            }
            if(text.TIPO==='autocomplete'){
              const Datos = thiss.state['json_'+text.NOMBRE].filter((row)=>thiss.Condicion(text.CONDICION,row[text.COLUMNA],event.target.value))
              thiss.setState({['datos_'+text.NOMBRE]: Datos})
            }
          })
          found=null
        }
      }
    })

    this.setState({[VARIABLE]: event.target.value})
}

onChangeAutocomplete = (VARIABLE)=> (event, newValue) =>{
  if (newValue!==null)
  {
    var thiss=this
 
    this.state.parametros.forEach(
      function getCheck(text, index) {
        var found
        if(text.NOMBRE===VARIABLE)
        {
          found=thiss.state.parametros.filter(grupo => grupo.SECUENCIA_PARAMETRO ===  text.SECUENCIA && grupo.ESPERA_PARAMETRO);
          //console.log(newValue)
          if(found!==null)
          {       
            found.forEach(function getCheck(text, index) {
              if(text.TIPO==='select'){
                const Datos = thiss.state['json_'+text.NOMBRE].filter((row)=>thiss.Condicion(text.CONDICION,row[text.COLUMNA],newValue.ID)).map((datos, i) =>
                  <MenuItem dense  value={datos.ID} key={datos.NOMBRE+text.NOMBRE} name={datos.NOMBRE}  >
                    {datos.NOMBRE}
                  </MenuItem>
                );
                thiss.setState({['datos_'+text.NOMBRE]: Datos})
              }
              if(text.TIPO==='autocomplete'){
                const Datos = thiss.state['json_'+text.NOMBRE].filter((row)=>thiss.Condicion(text.CONDICION,row[text.COLUMNA],newValue.ID))
                thiss.setState({['datos_'+text.NOMBRE]: Datos})
              }
            })
            found=null;
          }
        }
      })

      thiss.setState({[VARIABLE]:newValue});
  }  
}

Condicion=(condicion,valor1,valor2)=>{
  if(condicion==='='){if(valor1===valor2) return true;}
  if(condicion==='>='){if(valor1>=valor2) return true;}
  if(condicion==='<='){if(valor1<=valor2) return true;}
  if(condicion==='<'){if(valor1<valor2)   return true;}
  if(condicion==='>'){if(valor1>valor2)   return true;}
  if(condicion==='like'){if(valor1.toString().match(valor2.toString()))return true;}

  return false;
}

ChangeSelect = (VARIABLE)=> (event) =>{
  var thiss=this
 
  thiss.state.parametros.forEach(
    function getCheck(text, index) {
      var found
      if(text.NOMBRE===VARIABLE)
      {
        found=thiss.state.parametros.filter(grupo => grupo.SECUENCIA_PARAMETRO ===  text.SECUENCIA && grupo.ESPERA_PARAMETRO);

        if(found!==null)
        {
          
          found.forEach(function getCheck(text, index) {
            if(text.TIPO==='select'){
              const Datos = thiss.state['json_'+text.NOMBRE].filter((row)=>thiss.Condicion(text.CONDICION,row[text.COLUMNA],event.target.value)).map((datos, i) =>
                <MenuItem dense  value={datos.ID} key={datos.NOMBRE+text.NOMBRE} name={datos.NOMBRE}  >
                  {datos.NOMBRE}
                </MenuItem>
              );
              thiss.setState({['datos_'+text.NOMBRE]: Datos})
            }
            if(text.TIPO==='autocomplete'){
              const Datos = thiss.state['json_'+text.NOMBRE].filter((row)=>thiss.Condicion(text.CONDICION,row[text.COLUMNA],event.target.value))
              thiss.setState({['datos_'+text.NOMBRE]: Datos})
            }

          })
          found=null;
        }
      }
    })
    thiss.setState({[VARIABLE]:event.target.value});
}

changeswitch=()=>event=>{
    this.setState({switch: event.target.checked})
}

openchangedspeed=()=>{
  this.setState({open_speed:true})
}
closechangedspeed=()=>{
  this.setState({open_speed:false})
}
handleDateChange=(VARIABLE)=>(date)=>{
  this.setState({ [VARIABLE]: date }, ()=>{}); 
}

/*                                          RENDER                          */
render() {
    const { classes } = this.props;
   
    const botones = [
      {icono: 'CheckCircle', toolt: 'Generar Reporte',    nombre: 'Generar'   ,escritura:true , onclick: this.abrirgenerar()
      ,  display: 'auto'},
      {icono: 'DeleteSweepTwoToneIcon', toolt: 'Limpiar Parámetros',    nombre: 'Limpiar',escritura:true , onclick: this.botonlimpiar()
      ,  display: 'auto'},
      {icono: 'CancelIcon', toolt: 'Cancelar Parámetros',    nombre: 'Cancelar',disabled: this.state.parametros_final==='',escritura:true , onclick: this.botoncancelar()
      ,  display: 'auto',color:this.state.parametros_final===''?'grey':'red'},
    ]

    if (this.state.isLoggin === true )
    {
    if(this.state.label_reporte!=='')
    return (
    <React.Fragment>
      <Reporte id={"BT"+this.state.label_reporte} parametros={this.state.parametros_final} nom_boton="Generar" nom_bar="Reporte" 
        label_reporte={this.state.label_reporte} backcolor={colores.azul} fill={'white'} fullScreen={true} boton={false}  color="primary" color_bar='primary' variant='contained'
      />
      <Backdrop open={this.state.open_speed} style={{zIndex:1000,background:'rgba(0,0,0,0.8)',position:'absolute'}}/>
      <Backdrop className={classes.backdrop}  open={this.state.validando}>
          <CircularProgress color="inherit" />
          <span style={{ marginTop: '10px' }}>{'Validando...'}</span>
      </Backdrop>
      <div id={'div-reporte'+this.state.label_reporte.toString()} 
        key={'div-reporte'+this.state.label_reporte.toString()} style={{position:'absolute',bottom:0,top:0,left:0,right:0,overflow:'hidden'}}>
        <SpeedDial  ariaLabel="SpeedDial"
        icon={<SpeedDialIcon openIcon={<SettingsIcon />} icon={<SettingsTwoToneIcon/>} />}
        hidden={this.state.open_parametros}
        direction={'left'}
        onClose={this.closechangedspeed}
        onClick={this.openchangedspeed}
        open={this.state.open_speed}
        classes={{root: classes.root_speed,fab: classes.fab_speed, actionsClosed: classes.actionsClosed}}
        style={{textTransform:'none',position: 'absolute',top:2,right:2,}}
      >
        {((this.state.parametros_extras.length>0&&Auth.getProfile().plataforma===2)||(this.state.parametros.length>0&&Auth.getProfile().plataforma!==2))?
          <SpeedDialAction
            key={'PARAMS'}
            icon={<FilterListRoundedIcon color='primary' />}
            tooltipTitle={'Parámetros'} tooltipPlacement={'bottom'}
            onClick={()=>{return this.setState({open_parametros:true})}}
          />:null
        }
        {Auth.getProfile().plataforma!==2  && this.i?
          <SpeedDialAction
            key={'PRINT'}
            icon={<Icono icono={'Print'} color='primary' />} tooltipTitle={'Exportar'} tooltipPlacement={'bottom'}
            onClick={()=>{document.getElementById("BT"+this.state.label_reporte).click();}}
          />:null
        }
          <SpeedDialAction
            key={'REPRESH'}
            icon={<Icono icono={'RefreshIcon'} color='primary' />}
            tooltipTitle={'Refrescar'} tooltipPlacement={'bottom'}
            onClick={this.abrirgenerar()}
          />
        </SpeedDial>
        {document.getElementById('div-reporte'+this.state.label_reporte)!==null?
        <Drawer variant="temporary" anchor={'left'} open={this.state.open_parametros} 
          PaperProps={{ style: { position: 'absolute',width:movil_pequeño?'100%':window.innerWidth>1100?'35%':window.innerWidth<600?'80%':'45%',background:'#E0E0E0' } }}
          BackdropProps={{ style: { position: 'absolute' } }}
          ModalProps={{container: document.getElementById('div-reporte'+this.state.label_reporte),style: { position: 'absolute' }}}
        >
        <Paper key={'Paper1-'+this.state.label_reporte} style={{boxShadow: 'none',marginRight:movil_pequeño?0:5,borderTopLeftRadius:0,borderTopRightRadius:0,}}>
          <Typography align='center' variant='h6' style={{margin:10,fontWeight:'bold',color:'grey'}}>Parámetros</Typography>
        </Paper>
        <Paper key={'Paper2-'+this.state.label_reporte} style={{margin:10,marginTop:5,marginRight:movil_pequeño?10:15,marginBottom:5,borderTopLeftRadius:0,borderTopRightRadius:0,paddingBottom:10,paddingLeft:20,paddingRight:20,paddingTop:10}}>
        {
          !this.state.error?
            this.state.parametros.map((item,index) =>{
              if((Auth.getProfile().plataforma!==2)||(!item.ES_ALUMNO&&Auth.getProfile().plataforma===2))
              return(
                item.TIPO==='textfield'?
                <TextField key={this.state.label_reporte+'-'+item.NOMBRE} variant="outlined" margin="dense"
                  fullWidth={movil_pequeño}
                  label={item.ETIQUETA}
                  disabled={item.ESPERA_PARAMETRO?this.state[this.state.parametros[item.SECUENCIA_PARAMETRO].NOMBRE]!==''&&this.state[this.state.parametros[item.SECUENCIA_PARAMETRO].NOMBRE]!==null?false:true:false}
                  InputLabelProps={{shrink: true,}}
                  onChange={this.onChange(item.NOMBRE)}
                  value={this.state[item.NOMBRE]===undefined?'':this.state[item.NOMBRE]}
                  style={{marginTop:10,width:'50%',marginRight:5}}
                />
                :item.TIPO==='select'?this.state['datos_'+item.NOMBRE]!==undefined?
                <Select Label={item.ETIQUETA}
                  key={this.state.label_reporte+'-'+item.NOMBRE}
                  Datos = {this.state['datos_'+item.NOMBRE]}
                  Selected={this.state[item.NOMBRE]}
                  onChange={this.ChangeSelect(item.NOMBRE)}
                  disabled={item.ESPERA_PARAMETRO?this.state[this.state.parametros[item.SECUENCIA_PARAMETRO].NOMBRE]!==''&&this.state[this.state.parametros[item.SECUENCIA_PARAMETRO].NOMBRE]!==null?false:true:false}
                  Multiple = {false}
                  SelectClass={{height: movil_pequeño?'auto':36}}
                  Style = {classes.select}
                  ShowItemNone = {true}
                  shrink={this.state[item.NOMBRE]!==''?true:undefined}
                  LabelItemNone = '' ValueItemNone = ''
                  AutoFocus = {false}  Outlined = {true} //labelWidth = {item.ETIQUETA.length+5}
                />:<div key={'div-'+item.NOMBRE+this.state.label_reporte} style={{margin:20}}> <LinearProgress key={'LinearProgress-'+item.NOMBRE+this.state.label_reporte} color="primary"/></div>
                :item.TIPO==='autocomplete'?// && this.state['datos_'+item.NOMBRE]!==undefined?
                this.state['datos_'+item.NOMBRE]!==undefined?
                <Autocomplete
                key={this.state.label_reporte+'-'+item.NOMBRE} id={item.NOMBRE}
                loadingText={'Cargando...'}   
                ListboxComponent={ListboxComponent}
                clearText = 'Borrar'
                disabled={item.ESPERA_PARAMETRO?this.state[this.state.parametros[item.SECUENCIA_PARAMETRO].NOMBRE]!==''&&this.state[this.state.parametros[item.SECUENCIA_PARAMETRO].NOMBRE]!==null?false:true:false}
                disableListWrap autoHighlight required
                options={this.state['datos_'+item.NOMBRE]}
                getOptionLabel={(option) => option.NOMBRE + ' | ' + option.DESCRIPCION}
                renderInput={(params) => <TextField {...params} label={item.ETIQUETA} variant="outlined" />}
                value={this.state[item.NOMBRE]}
                getOptionSelected = {(option, value) => option.ID === value.ID}
                onChange={this.onChangeAutocomplete(item.NOMBRE)}   
                />:<div key={'div-'+item.NOMBRE+this.state.label_reporte} style={{margin:20}}> <LinearProgress key={'LinearProgress-'+item.NOMBRE+this.state.label_reporte} color="primary"/></div>
                :item.TIPO==='muipickers'?
                <MuiPickersUtilsProvider key={this.state.label_reporte+'-'+item.NOMBRE} utils={DateFnsUtils} locale={esLocale}>
                <KeyboardDatePicker
                  variant="inline" inputVariant="outlined"
                  format="dd / MM / yyyy" margin="dense"
                  disabled={item.ESPERA_PARAMETRO?this.state[this.state.parametros[item.SECUENCIA_PARAMETRO].NOMBRE]!==''&&this.state[this.state.parametros[item.SECUENCIA_PARAMETRO].NOMBRE]!==null?false:true:false}
                  id={item.NOMBRE}                                    
                  label={item.ETIQUETA}
                  value={this.state[item.NOMBRE]}
                  onChange={this.handleDateChange(item.NOMBRE)}                                                                                                                                                                                
                  InputProps={{ style:{ paddingRight: '1px', readOnly: true }, readOnly: true }}    
                  style={{ marginTop: 5, width: !movil_pequeño ? '50%' : '100%' }}
                  autoOk
                  className = {classes.textField} ToolbarComponent={CustomToolbar}                      
                />
                </MuiPickersUtilsProvider>              
                :null
              );
              else
              return null;
            })
            :<div key={'div-error-'+this.state.label_reporte} style={{margin:20}}>Hay un error en el parámetro "<b>{this.state.parametro_error}</b>", contacte a <b>{globales.correo_soporte}</b></div>
            
        }
        </Paper>
        <Paper style={{marginLeft:10,marginRight:movil_pequeño?10:15,paddingBottom:1,paddingLeft:1,paddingRight:1,paddingTop:1}}>
          <BarraBotones align='center' botones={botones} l={this.l} e={this.e} i={this.i} />
        </Paper>
        {Auth.getProfile().plataforma!==2 && this.i?
        <FormControlLabel key={'FormControlLabel'+this.state.label_reporte}
            control={<Switch checked={this.state.switch} 
            classes={{root: classes.root,switchBase: classes.Switch,thumb: classes.thumb,track: classes.track,checked: classes.checked,}} 
            onChange={this.changeswitch()}/>} label="Exportar"
            style={{marginLeft: 5,display:'flex'}}
        />:null
        }
        </Drawer>:null
        }
        {this.state.cargando?
        <Backdrop open={true} className={classes.backdrop} style={{position:'absolute'}}>
          <CircularProgress color="inherit" />
          <span style={{ marginTop: '10px' }}>{'Cargando...'}</span>
        </Backdrop>:null}
        <embed onLoad={()=>{this.setState({cargando:false})}} src={this.state.url} id="Reporte" title='Reporte' frameBorder="0" width="100%" height="100%"></embed>
        </div>
    </React.Fragment>
    ); /// finaliza return
    else
    return null;
    }
    else if (this.state.isLoggin === false)
    {
        Auth.logout()
        window.location.reload();
        return; 
    }


    return null;
} /// finaliza render
} /// finaliza class
)/// finaliza withStyles

    

    